import type { JSX } from 'react'

export const PicInPicIcon = (): JSX.Element => (
  <use href='#picInPicIcon' height='100%' width='100%' />
)
